import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ShowRedeemBrand from "../../../components/SuperAdmin/RedeemBrand/ShowRedeemBrand";

export default withRouter(connect()(ShowRedeemBrand));
